"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.DownloadIcon = function () {
    return (react_1.default.createElement("svg", { id: "download-icon", width: "24", height: "24" },
        react_1.default.createElement("path", { fill: "#0098db", id: "download-a", d: "M11,4 L13,4 L13,11 L17.031,11 L12.012,15.938 L6.977,11 L11.009,11 L11,4 Z M4,20 L4,18 L20,18 L20,20 L4,20 Z" })));
};
